<template>
  <div class="Big">
    <div class="BigCenter">
      <div class="content" v-html="List.content"></div>
    </div>
    <!-- 移动端 -->
    <div class="m-center">
      <div class="m-content">
        <div class="m-content-title">
          <div class="m-content-title-logo">
            <img :src="info.logo"/>
          </div>
          <div class="m-title">{{info.title}}</div>
          <div class="m-subtitle">{{info.keyword.split('###')[0]}}</div>
        </div>
        <div class="m-content-des">
          <div><span>公司地址：</span><span>{{info.address}}</span></div>
          <div><span>联系电话：</span><span>{{info.mobile}}</span></div>
          <div><span>电子邮件：</span><span>{{info.email}}</span></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { WOW } from "wowjs";
import { GetColumn_List,GetHF } from "@/https/http";
export default {
  data() {
    return {
      List: "",
      info:'',
    };
  },
  created() {
    GetColumn_List({
      column_id: this.$route.query.id,
      modular: this.$route.query.modular,
    }).then((res) => {
      this.List = res.result;
      console.log("this.List", this.List);
    });
    GetHF().then(res=>{
      this.info = res.result
      console.log(res,'info')
    })
  },
  mounted() {
    window.addEventListener("scroll", this.windowScroll);
    this.$parent.color = `#000`;
    this.$parent.backgroundColor = "#fff";
    let wow = new WOW({
      boxClass: "wow", //需要执行动画的元素的 class
      animateClass: "animated", //animation.css 动画的 class
      offset: 0, //距离可视区域多少开始执行动画
      mobile: true, //是否在移动设备上执行动画
      live: true, //异步加载的内容是否有效
    });
    wow.init();
  },
};
</script>
<style lang="scss" scoped>
@media screen and(min-width:1020px){
  .Big {
  display: flex;
  width: 100%;
  margin-top: 100px;
  margin-bottom: 100px;
  .BigCenter {
    width: 1440px;
    min-width: 1440px;
    margin: 0 auto;
  }
  .m-center{
    display: none;
  }
}
}
@media screen and(max-width:1020px){
  .Big{
    width: 100%;
    .BigCenter{
      display:none;
    }
    .m-center{
      display: block;
      width: 85%;
      margin:0 auto;

      .m-content-title-logo{
        margin-top:20px;
        width:60%;
        img{
          width: 100%;
        }
      }
      .m-title{
        font-size:24px;
        font-weight:600;
      }
      .m-subtitle{
        margin-top:5px;
        font-size:16px;
        color:#999;
      }
      .m-content-des{
        margin-top:40px;
      }
    }
  }
}
</style>